import gql from 'graphql-tag';
import { query } from '../../client';
import { ORDER_FIELDS } from '../fragments/ordersFields';
import { INVENTORY_FIELDS } from '../fragments/inventoryFields';
export const GetOrders = gql `
  ${ORDER_FIELDS}
  ${INVENTORY_FIELDS}

  query OrdersQuery($userId: ID!, $limit: Int!, $offset: Int) {
    orders(userId: $userId, limit: $limit, offset: $offset) @rest(type: "OrderResult", path: "orders/query/?filter[contain]=transaction&userId={args.userId}&limit={args.limit}&offset={args.offset}") {
      meta {
        total
      }
      data @type(name: "Order") {
        ...OrderFields
        products {
          id
          name
          type
          updatedAt
          createdAt
          inventory @type(name: "Inventory") {
            ...InventoryFields
          }
        }
        extras {
          next {
            membershipId
          }
        }
        createdAt
        updatedAt
      }
    }
  }
`;
// Query orders from OMNI.
export function getOrders(userId, limit, offset) {
    return query({
        query: GetOrders,
        variables: {
            userId,
            limit,
            offset,
        },
    });
}
export default getOrders;
